import { createContext, type ReactNode, useContext } from "react";
import { parseAccessPolicy } from "../lib/parse-permissions";
import type { Permissions } from "../types";

// Default permissions (no access)
const defaultPermissions = parseAccessPolicy(null, false);

interface PermissionsContextValue {
  permissions: Permissions;
  refetch: () => Promise<void>;
  clear: () => void;
}

const defaultContextValue: PermissionsContextValue = {
  permissions: defaultPermissions,
  refetch: async () => {},
  clear: () => {},
};

const PermissionsContext = createContext<PermissionsContextValue>(defaultContextValue);

interface PermissionsProviderProps {
  permissions: Permissions;
  refetch: () => Promise<void>;
  clear: () => void;
  children: ReactNode;
}

export function PermissionsProvider({ permissions, refetch, clear, children }: PermissionsProviderProps) {
  return <PermissionsContext.Provider value={{ permissions, refetch, clear }}>{children}</PermissionsContext.Provider>;
}

export function usePermissionsContext(): PermissionsContextValue {
  return useContext(PermissionsContext);
}
